import { render, staticRenderFns } from "./Techniques.vue?vue&type=template&id=2d9f8ac8&scoped=true"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"
import style0 from "./Techniques.vue?vue&type=style&index=0&id=2d9f8ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f8ac8",
  null
  
)

export default component.exports